import type { SVGProps } from "react";

import { CHEVRON_STROKE_WIDTH } from "./chevron-stroke";

// Chevron on a filled circle: the circle inherits the svg `fill` (the
// CarouselButton fillColor), the chevron stays `currentColor`.

const ChevronCircleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx={12} cy={12} r={12} />
    <g transform="translate(1 0)">
      <path
        d="M9 6L15 12L9 18"
        fill="none"
        stroke="currentColor"
        strokeWidth={CHEVRON_STROKE_WIDTH}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default ChevronCircleRight;
